import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import CourseFlag from "./CourseFlag";

export default function CourseFlags(props) {
  return props.flags ? (
    <Box display="flex" alignItems="center">
      {props.flags.map((courseFlag, index) => (
        <CourseFlag key={index} courseFlag={courseFlag} size={props.size} />
      ))}
    </Box>
  ) : null;
}

CourseFlags.propTypes = {
  flags: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.oneOf(["default", "small"])
};

CourseFlags.defaultProps = {
  size: "default"
};
